import { Card } from "@/components/ui/card";
import { Text } from "@/components/ui/text";
import { Heading } from "@/components/ui/heading";
import { WalletDTO } from "@/generated/api/models";
import { useSumFormatter } from "@/utils/useSumFormatter";
import { Icon } from "@/components/ui/icon";
import { ChevronRight, Plus, Wallet } from "lucide-react-native";
import { HStack } from "@/components/ui/hstack";
import { Avatar } from "@/components/ui/avatar";
import { VStack } from "@/components/ui/vstack";
import { RestaurantWalletModalCreate } from "./restaurant.wallet.modal";
import { useState } from "react";
import { Pressable } from "@/components/ui/pressable";

export function RestaurantWalletItemFull({ wallet }: { wallet: WalletDTO }) {
  const { formatCents, currencyCode } = useSumFormatter({
    asset: wallet.currency,
  });

  return (
    <HStack
      space="md"
      className="border border-background-300 rounded-lg p-4 items-center justify-between w-full"
    >
      <HStack space="xl" className="items-center">
        <Avatar>
          <Icon as={Wallet} size="lg" className="stroke-white" />
        </Avatar>
        <VStack>
          <Text className="font-semibold text-typography-900 text-lg line-clamp-1">
            {wallet.name ?? `${currencyCode} Wallet`}
          </Text>

          <Text size="sm">
            {formatCents(wallet.balance + wallet.holdBalance)}
          </Text>
        </VStack>
      </HStack>
      <Icon as={ChevronRight} />
    </HStack>
  );
}

export function RestaurantWalletItemMini({ wallet }: { wallet: WalletDTO }) {
  const { formatCents } = useSumFormatter({
    asset: wallet.currency,
  });

  return (
    <Card size="md" variant="filled" className="justify-between h-full w-full">
      <Heading
        size="sm"
        className="mb-1 text-ellipsis overflow-hidden whitespace-nowrap"
        numberOfLines={1}
        ellipsizeMode="tail"
      >
        {wallet.name}
      </Heading>
      <Text size="sm">{formatCents(wallet.balance + wallet.holdBalance)}</Text>
    </Card>
  );
}

export function RestaurantWalletItemCreateMini(props: {
  organizationId: string;
}) {
  const [showCreation, setShowCreation] = useState(false);

  return (
    <>
      <Pressable className="h-full w-36" onPress={() => setShowCreation(true)}>
        <Card
          size="md"
          variant="outline"
          className="justify-between align-middle h-full w-full border-dashed"
        >
          <Icon as={Plus} />
          <Heading size="xs">New wallet</Heading>
        </Card>
        <RestaurantWalletModalCreate
          organizationId={props.organizationId}
          isOpen={showCreation}
          onClose={() => setShowCreation(false)}
        />
      </Pressable>
    </>
  );
}
